import { Dispatch } from 'react';
import { parseInt } from 'lodash/fp';

import { Customer } from '../../../../selectors/select-customer/types';
import { CustomerActionType } from '../../../../actions/customer';
import { ProductType } from '../../../../types/product';
import hasHospitalComponent from '../../../../utils/has-hospital-component';

const getUnavailableProductProps = (
  changeExcessFunction: CustomerActionType['customer']['changeHospitalExcess'],
  hospitalExcess: Customer['hospitalExcess'],
  product: ProductType,
  dispatch?: Dispatch<any>,
) => {
  const DEFAULT_EXCESS = '750';
  const RADIX = 10;
  const customerExcess = parseInt(RADIX, hospitalExcess);
  const productExcess = product?.charges?.excess?.amount;
  const isUnavailableProduct = hasHospitalComponent(product) && customerExcess !== productExcess;

  return isUnavailableProduct
    ? {
        changeExcess: () =>
          dispatch ? dispatch(changeExcessFunction(DEFAULT_EXCESS)) : changeExcessFunction(DEFAULT_EXCESS),
        changeTo: parseInt(RADIX, DEFAULT_EXCESS),
        current: customerExcess,
      }
    : null;
};

export default getUnavailableProductProps;
